import React, { createContext, useContext, useEffect, useState } from "react";
import { ANNOUNCEMENTS, HERO_SLIDES, PROMO_CARDS } from "../mock/mock";

const ContentContext = createContext(null);
const LS_KEY = "ardf_site_override_v1";

const DEFAULTS = {
  announcements: ANNOUNCEMENTS.map((t, i) => ({ id: `a${i}`, text: t, active: true })),
  hero_slides: HERO_SLIDES.map((s) => ({ ...s, active: true })),
  promo_cards: PROMO_CARDS.map((c) => ({ ...c, active: true })),
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULTS);

  useEffect(() => {
    const load = async () => {
      try {
        const raw = localStorage.getItem(LS_KEY);
        if (raw) {
          const site = JSON.parse(raw);
          if (site) {
            setContent({
              announcements: site.announcements || DEFAULTS.announcements,
              hero_slides: site.hero_slides || DEFAULTS.hero_slides,
              promo_cards: site.promo_cards || DEFAULTS.promo_cards,
            });
            return;
          }
        }
      } catch (e) {}
      try {
        const res = await fetch(`${process.env.PUBLIC_URL || ""}/data/site.json`, { cache: "no-store" });
        if (res.ok) {
          const site = await res.json();
          setContent({
            announcements: site.announcements || DEFAULTS.announcements,
            hero_slides: site.hero_slides || DEFAULTS.hero_slides,
            promo_cards: site.promo_cards || DEFAULTS.promo_cards,
          });
        }
      } catch (e) {}
    };
    load();
  }, []);

  return <ContentContext.Provider value={{ content }}>{children}</ContentContext.Provider>;
};

export const useContent = () => {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error("useContent must be used inside ContentProvider");
  return ctx;
};
